import { render, staticRenderFns } from "./TabNav.vue?vue&type=template&id=790d8d82&scoped=true&"
import script from "./TabNav.vue?vue&type=script&lang=js&"
export * from "./TabNav.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "790d8d82",
  null
  
)

export default component.exports